import { Ref } from 'react'

interface BankQuestionIconProps {
  questionMarkRef?: Ref<SVGGElement>
  className?: string
}

export const BankQuestionIcon = ({
  questionMarkRef,
  className,
}: BankQuestionIconProps) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g>
      <g style={{ mixBlendMode: 'multiply' }}>
        <path
          d="M76.7324 64.6743C76.7367 66.5194 60.2121 68.0479 39.8244 68.0936C19.4366 68.1394 1.01203 66.6893 1.00774 64.8443C1.00346 62.9992 19.4211 61.4665 39.8089 61.4207C60.1966 61.375 76.7281 62.8326 76.7324 64.6743Z"
          fill="#90B3A8"
        />
      </g>
      <g>
        <path
          d="M43.1152 37.8247V61.8979H43.415V37.8247H73.6572V62.3394H17.8945V37.8247H43.1152Z"
          fill="#FCEDB6"
          stroke="#1D1D1D"
          strokeWidth="0.3"
        />
        <g style={{ opacity: 0.3, mixBlendMode: 'multiply' }}>
          <path
            d="M17.7441 37.6743H43.2654H73.8072V62.4891H17.7441V37.6743Z"
            fill="#F2D891"
          />
        </g>
        <g>
          <path
            d="M78.9991 62.8618V66.525C78.9991 67.0773 78.5514 67.525 77.9991 67.525H45.2742H14.3359C13.7837 67.525 13.3359 67.0773 13.3359 66.525V62.8618C13.3359 62.3095 13.7837 61.8618 14.3359 61.8618H45.2742H77.9991C78.5514 61.8618 78.9991 62.3095 78.9991 62.8618Z"
            fill="#FCF1D4"
          />
          <path
            d="M45.2742 61.8618H77.9991C78.5514 61.8618 78.9991 62.3095 78.9991 62.8618V66.525C78.9991 67.0773 78.5514 67.525 77.9991 67.525H45.2742M45.2742 61.8618H14.3359C13.7837 61.8618 13.3359 62.3095 13.3359 62.8618V66.525C13.3359 67.0773 13.7837 67.525 14.3359 67.525H45.2742M45.2742 61.8618V67.525"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
        </g>
        <g style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M23.8555 40.147C23.8555 40.38 23.6666 40.5688 23.4336 40.5688C23.2006 40.5688 23.0117 40.7577 23.0117 40.9907V58.5649C23.0117 58.7979 23.2006 58.9868 23.4336 58.9868C23.6666 58.9868 23.8555 59.1757 23.8555 59.4087V61.4438C23.8555 61.6768 23.6666 61.8657 23.4336 61.8657H23.0151C23.0132 61.8657 23.0117 61.8673 23.0117 61.8691C23.0117 61.871 23.0102 61.8726 23.0083 61.8726H18.7905C18.7886 61.8726 18.7871 61.871 18.7871 61.8691C18.7871 61.8673 18.7856 61.8657 18.7837 61.8657H18.3643C18.1307 61.8657 17.9414 61.6764 17.9414 61.4429V59.4097C17.9414 59.1761 18.1307 58.9868 18.3643 58.9868C18.5978 58.9868 18.7871 58.7975 18.7871 58.564V40.9917C18.7871 40.7582 18.5978 40.5688 18.3643 40.5688C18.1307 40.5688 17.9414 40.3795 17.9414 40.146V38.6899C17.9414 38.1377 18.3891 37.6899 18.9414 37.6899H22.8555C23.4078 37.6899 23.8555 38.1377 23.8555 38.6899V40.147Z"
            fill="#FCEDB6"
          />
        </g>
        <g style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M33.0703 40.147C33.0703 40.38 32.8814 40.5688 32.6484 40.5688C32.4154 40.5688 32.2266 40.7577 32.2266 40.9907V58.5649C32.2266 58.7979 32.4154 58.9868 32.6484 58.9868C32.8814 58.9868 33.0703 59.1757 33.0703 59.4087V61.4438C33.0703 61.6768 32.8814 61.8657 32.6484 61.8657H32.23C32.2281 61.8657 32.2266 61.8673 32.2266 61.8691C32.2266 61.871 32.225 61.8726 32.2231 61.8726H28.0054C28.0035 61.8726 28.002 61.871 28.002 61.8691C28.002 61.8673 28.0004 61.8657 27.9985 61.8657H27.5791C27.3456 61.8657 27.1562 61.6764 27.1562 61.4429V59.4097C27.1562 59.1761 27.3456 58.9868 27.5791 58.9868C27.8126 58.9868 28.002 58.7975 28.002 58.564V40.9917C28.002 40.7582 27.8126 40.5688 27.5791 40.5688C27.3456 40.5688 27.1562 40.3795 27.1562 40.146V38.6899C27.1562 38.1377 27.604 37.6899 28.1563 37.6899H32.0703C32.6226 37.6899 33.0703 38.1377 33.0703 38.6899V40.147Z"
            fill="#FCEDB6"
          />
        </g>
        <g style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M42.8672 40.147C42.8672 40.38 42.6783 40.5688 42.4453 40.5688C42.2123 40.5688 42.0234 40.7577 42.0234 40.9907V58.5649C42.0234 58.7979 42.2123 58.9868 42.4453 58.9868C42.6783 58.9868 42.8672 59.1757 42.8672 59.4087V61.4438C42.8672 61.6768 42.6783 61.8657 42.4453 61.8657H42.0269C42.025 61.8657 42.0234 61.8673 42.0234 61.8691C42.0234 61.871 42.0219 61.8726 42.02 61.8726H37.8022C37.8004 61.8726 37.7988 61.871 37.7988 61.8691C37.7988 61.8673 37.7973 61.8657 37.7954 61.8657H37.376C37.1424 61.8657 36.9531 61.6764 36.9531 61.4429V59.4097C36.9531 59.1761 37.1424 58.9868 37.376 58.9868C37.6095 58.9868 37.7988 58.7975 37.7988 58.564V40.9917C37.7988 40.7582 37.6095 40.5688 37.376 40.5688C37.1424 40.5688 36.9531 40.3795 36.9531 40.146V38.6899C36.9531 38.1377 37.4008 37.6899 37.9531 37.6899H41.8672C42.4195 37.6899 42.8672 38.1377 42.8672 38.6899V40.147Z"
            fill="#FCEDB6"
          />
        </g>
        <g style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M56.6895 40.147C56.6895 40.38 56.5006 40.5688 56.2676 40.5688C56.0346 40.5688 55.8457 40.7577 55.8457 40.9907V58.5649C55.8457 58.7979 56.0346 58.9868 56.2676 58.9868C56.5006 58.9868 56.6895 59.1757 56.6895 59.4087V61.4438C56.6895 61.6768 56.5006 61.8657 56.2676 61.8657H55.8491C55.8472 61.8657 55.8457 61.8673 55.8457 61.8691C55.8457 61.871 55.8442 61.8726 55.8423 61.8726H51.6245C51.6226 61.8726 51.6211 61.871 51.6211 61.8691C51.6211 61.8673 51.6196 61.8657 51.6177 61.8657H51.1982C50.9647 61.8657 50.7754 61.6764 50.7754 61.4429V59.4097C50.7754 59.1761 50.9647 58.9868 51.1982 58.9868C51.4318 58.9868 51.6211 58.7975 51.6211 58.564V40.9917C51.6211 40.7582 51.4318 40.5688 51.1982 40.5688C50.9647 40.5688 50.7754 40.3795 50.7754 40.146V38.6899C50.7754 38.1377 51.2231 37.6899 51.7754 37.6899H55.6895C56.2417 37.6899 56.6895 38.1377 56.6895 38.6899V40.147Z"
            fill="#FCEDB6"
          />
        </g>
        <g style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M66.4824 40.147C66.4824 40.38 66.2935 40.5688 66.0605 40.5688C65.8276 40.5688 65.6387 40.7577 65.6387 40.9907V58.5649C65.6387 58.7979 65.8276 58.9868 66.0605 58.9868C66.2935 58.9868 66.4824 59.1757 66.4824 59.4087V61.4438C66.4824 61.6768 66.2935 61.8657 66.0605 61.8657H65.6421C65.6402 61.8657 65.6387 61.8673 65.6387 61.8691C65.6387 61.871 65.6371 61.8726 65.6353 61.8726H61.4175C61.4156 61.8726 61.4141 61.871 61.4141 61.8691C61.4141 61.8673 61.4125 61.8657 61.4106 61.8657H60.9912C60.7577 61.8657 60.5684 61.6764 60.5684 61.4429V59.4097C60.5684 59.1761 60.7577 58.9868 60.9912 58.9868C61.2247 58.9868 61.4141 58.7975 61.4141 58.564V40.9917C61.4141 40.7582 61.2247 40.5688 60.9912 40.5688C60.7577 40.5688 60.5684 40.3795 60.5684 40.146V38.6899C60.5684 38.1377 61.0161 37.6899 61.5684 37.6899H65.4824C66.0347 37.6899 66.4824 38.1377 66.4824 38.6899V40.147Z"
            fill="#FCEDB6"
          />
        </g>
        <g>
          <rect
            x="26.8609"
            y="37.8399"
            width="3.92418"
            height="24.2425"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
          <rect
            x="26.0152"
            y="59.4649"
            width="5.61385"
            height="2.62173"
            rx="0.85"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
          <rect
            x="26.0152"
            y="37.8399"
            width="5.61385"
            height="2.62173"
            rx="0.85"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
        </g>
        <g>
          <rect
            x="17.566"
            y="37.8399"
            width="3.92418"
            height="24.2425"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
          <rect
            x="16.7203"
            y="59.4649"
            width="5.61385"
            height="2.62173"
            rx="0.85"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
          <rect
            x="16.7203"
            y="37.8399"
            width="5.61385"
            height="2.62173"
            rx="0.85"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
        </g>
        <g>
          <rect
            x="36.5797"
            y="37.8399"
            width="3.92418"
            height="24.2425"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
          <rect
            x="35.734"
            y="59.4649"
            width="5.61385"
            height="2.62173"
            rx="0.85"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
          <rect
            x="35.734"
            y="37.8399"
            width="5.61385"
            height="2.62173"
            rx="0.85"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
        </g>
        <g>
          <rect
            x="60.234"
            y="37.8399"
            width="3.92418"
            height="24.2425"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
          <rect
            x="59.3883"
            y="59.4649"
            width="5.61385"
            height="2.62173"
            rx="0.85"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
          <rect
            x="59.3883"
            y="37.8399"
            width="5.61385"
            height="2.62173"
            rx="0.85"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
        </g>
        <g>
          <rect
            x="69.9469"
            y="37.8399"
            width="3.92418"
            height="24.2425"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
          <rect
            x="69.1012"
            y="59.4649"
            width="5.61385"
            height="2.62173"
            rx="0.85"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
          <rect
            x="69.1012"
            y="37.8399"
            width="5.61385"
            height="2.62173"
            rx="0.85"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
        </g>
        <g>
          <rect
            x="50.5133"
            y="37.8399"
            width="3.92418"
            height="24.2425"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
          <rect
            x="49.6676"
            y="59.4649"
            width="5.61385"
            height="2.62173"
            rx="0.85"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
          <rect
            x="49.6676"
            y="37.8399"
            width="5.61385"
            height="2.62173"
            rx="0.85"
            fill="#FCF1D4"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
        </g>
        <g>
          <path
            d="M14.4599 31.975L29.4557 19.8774H58.0946C58.2883 19.8774 58.4778 19.9337 58.6401 20.0393L76.9778 31.975H77.711C78.2632 31.975 78.711 32.4227 78.711 32.975V36.784C78.711 37.3363 78.2632 37.784 77.711 37.784H44.8683H13.7598C13.2075 37.784 12.7598 37.3363 12.7598 36.784V32.975C12.7598 32.4227 13.2075 31.975 13.7598 31.975H14.4599Z"
            fill="#FCF1D4"
          />
          <path
            d="M76.9778 31.975H44.8683M14.4599 31.975L29.4557 19.8774H58.0946C58.2883 19.8774 58.4778 19.9337 58.6401 20.0393L76.9778 31.975M76.9778 31.975H77.711C78.2632 31.975 78.711 32.4227 78.711 32.975V36.784C78.711 37.3363 78.2632 37.784 77.711 37.784H44.8683M14.4599 31.975H44.8683M14.4599 31.975H13.7598C13.2075 31.975 12.7598 32.4227 12.7598 32.975V36.784C12.7598 37.3363 13.2075 37.784 13.7598 37.784H44.8683M44.8683 31.975V37.784M44.8683 31.975L29.4557 19.8774"
            stroke="#1D1D1D"
            strokeWidth="0.3"
          />
        </g>
      </g>
    </g>
    {/* Static wrapper handles positioning (shifted down to overlap the roof
     * instead of floating above it, clipped by the 80x80 canvas); the
     * inner ref'd group is left untouched by that transform so GSAP's
     * scale/opacity pop-in animates purely in place. */}
    <g transform="translate(0, 14)">
      <g ref={questionMarkRef}>
        <path
          d="M63.8438 3.63477C70.6629 3.63477 76.1934 9.2235 76.1934 16.1211C76.1932 23.0186 70.6628 28.6074 63.8438 28.6074C57.0247 28.6074 51.4943 23.0186 51.4941 16.1211C51.4941 9.2235 57.0246 3.63477 63.8438 3.63477Z"
          fill="#FCF1D4"
          stroke="#1D1D1D"
          strokeWidth="0.3"
        />
        <path
          d="M63.8438 5.43896C69.6767 5.43896 74.4081 10.2191 74.4082 16.1196C74.4082 22.0202 69.6767 26.8013 63.8438 26.8013C58.011 26.801 53.2803 22.0201 53.2803 16.1196C53.2804 10.2192 58.011 5.43919 63.8438 5.43896Z"
          fill="white"
          stroke="#1D1D1D"
          strokeWidth="0.3"
        />
        <g>
          <circle
            cx="63.6206"
            cy="22.7607"
            r="1.6206"
            fill="#E5C267"
            stroke="#1D1D1D"
            strokeWidth="0.3"
            strokeLinecap="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M62.4111 8.11377C63.1198 7.87787 63.8355 7.81011 64.5866 7.82212C65.8517 7.84234 67.2605 8.17071 68.3175 9.03755C69.45 9.96633 69.9534 11.3293 69.6756 12.9357C69.5285 13.7867 69.167 14.468 68.5985 15.0011C68.0704 15.4963 67.4492 15.7759 67.0228 15.9599C66.9732 15.9813 66.9251 16.0019 66.8785 16.022C66.0621 16.373 65.7069 16.5257 65.409 17.0415C65.2738 17.2758 65.2141 17.5854 65.2068 17.8766C65.2038 17.9939 65.2099 18.0882 65.2154 18.1442C65.2232 18.1803 65.2296 18.2169 65.2344 18.2541C65.2366 18.2702 65.241 18.3055 65.2439 18.3483C65.2451 18.365 65.2485 18.4163 65.2465 18.4813C65.2457 18.5093 65.2429 18.5847 65.2256 18.6797C65.2171 18.726 65.1984 18.8166 65.156 18.9258C65.1254 19.0048 65.0214 19.2618 64.7482 19.4983C64.3814 19.8159 63.7898 20.0136 63.162 19.8442C62.7046 19.7208 62.4517 19.4556 62.3808 19.3788C62.2193 19.2039 62.1425 19.0331 62.1291 19.0032C62.1285 19.002 62.1281 19.0011 62.1277 19.0003C62.085 18.9069 62.0624 18.8285 62.0576 18.8117L62.0571 18.8102C62.0422 18.7588 62.0332 18.7163 62.03 18.7012C62.0149 18.629 62.0033 18.5489 61.9946 18.4749C61.9759 18.3147 61.9595 18.0843 61.9664 17.81C61.9797 17.2818 62.082 16.4737 62.5348 15.6896C63.3554 14.2685 64.653 13.7271 65.4238 13.4055C65.4957 13.3755 65.5631 13.3474 65.625 13.3207C66.0215 13.1496 66.173 13.0572 66.2632 12.9726C66.313 12.926 66.4153 12.8197 66.4732 12.4847C66.6056 11.7192 66.3609 11.3855 66.1377 11.2024C65.839 10.9575 65.2846 10.7589 64.5292 10.7469C64.0328 10.7389 63.7471 10.7869 63.5326 10.8583C63.3182 10.9296 63.0664 11.0606 62.6945 11.3575C62.0242 11.8928 61 11.8363 60.4069 11.2314C59.8138 10.6264 59.8764 9.70208 60.5467 9.1668C61.1093 8.7175 61.7024 8.34966 62.4111 8.11377ZM62.0152 18.5941C62.0154 18.5956 62.0156 18.5967 62.0157 18.5975L62.0157 18.5977C62.0155 18.5965 62.0154 18.5953 62.0152 18.5941Z"
            fill="#E5C267"
            stroke="#1D1D1D"
            strokeWidth="0.3"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
)
